import { apiV2 } from "./api"

function getProducts() {
  return apiV2("products")
}

export { getProducts }
